import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapCompetitionsComponent } from './bootstrap-competitions/bootstrap-competitions.component';


const routes: Routes = [{
  path: '', component: BootstrapCompetitionsComponent,
  children: [
    { path: '', loadChildren: () => import('./event-info/competition-event-info.module').then(m => m.CompetitionEventInfoModule) },
    { path: 'results', loadChildren: () => import('./angular-js/angular-js.module').then(m => m.AngularJsModule) },

    {path:'quotes', loadChildren: ()=> import('./competition-quotes/competition-quotes.module').then(m => m.CompetitionQuotesModule)},
    { path: 'news', loadChildren: () => import('./competitions-news/competitions-news.module').then(m => m.CompetitionsNewsModule) },
    { path: 'photos', loadChildren: () => import('./competitions-photos/competitions-photos.module').then(m => m.CompetitionsPhotosModule) },
    { path: 'entries', loadChildren: () => import('./competition-entries/competition-entries.module').then(m => m.CompetitionEntriesModule) },


    {path:'ranking', loadChildren: () => import('./competition-ranking/competition-ranking.module').then(m => m.CompetitionRankingModule)},
    { // PErform redirection from table.
      path:'ranking/entries',
      redirectTo:'entries'
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetitionsRoutingModule { }
